import React, { useEffect, useState } from 'react';
import Login from './Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import StatusLegendCRUD from './components/StatusLegendCRUD';
import UsersCRUD from './components/UsersCRUD';
import SetupSala from './components/SetupSala';
import SalasCirurgicas from './components/SalasCirurgicas';
import Reports from './components/Reports';
import Pacientes from './components/Pacientes';
import Scheduling from './components/Scheduling';
import FluxoSala from './components/FluxoSala';
import ConfigCC from './components/ConfigCC';
import CustomMetrics from './components/CustomMetrics';
import SalasTempos from './components/SalasTempos';
import './App.css';

interface User {
  id: string;
  email: string;
  fullName: string;
  role: string;
}

type PageId = 'dashboard' | 'salas' | 'setup-sala' | 'cadastros' | 'usuarios' | 'relatorios' | 'pacientes' | 'schedules' | 'fluxo-sala' | 'config-cc' | 'custom-metrics' | 'salas-tempos';

function App() {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('token'));
  const [user, setUser] = useState<User | null>(() => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      return null;
    }

    try {
      return JSON.parse(storedUser) as User;
    } catch {
      return null;
    }
  });
  const [currentPage, setCurrentPage] = useState<PageId>(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const u = JSON.parse(storedUser);
        if (u?.role === 'User' || u?.role === 'Usuário') return 'setup-sala';
      } catch {}
    }
    return 'dashboard';
  });

  useEffect(() => {
    if (!token) {
      setUser(null);
    }
  }, [token]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setCurrentPage('dashboard');
  };

  const handleLoginSuccess = (newToken: string, newUser: User) => {
    setToken(newToken);
    setUser(newUser);
    // User/Usuário goes to Setup Sala; Admin/Master goes to Dashboard
    const role = newUser?.role || 'User';
    if (role === 'User' || role === 'Usuário') {
      setCurrentPage('setup-sala');
    } else {
      setCurrentPage('dashboard');
    }
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard onOpenSetupSala={(roomId) => {
          localStorage.setItem('setupRoomId', roomId);
          setCurrentPage('setup-sala');
        }} />;
      case 'setup-sala':
        return <SetupSala />;
      case 'cadastros':
        return <StatusLegendCRUD />;
      case 'usuarios':
        return <UsersCRUD />;
      case 'salas':
        return <SalasCirurgicas />;
      case 'pacientes':
        return <Pacientes />;
      case 'schedules':
        return <Scheduling />;
      case 'fluxo-sala':
        return <FluxoSala />;
      case 'config-cc':
        return <ConfigCC />;
      case 'custom-metrics':
        return <CustomMetrics />;
      case 'salas-tempos':
        return <SalasTempos />;
      case 'relatorios':
        return <Reports />;
      default:
        return <Dashboard />;
    }
  };

  if (!token) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <Layout
      user={user}
      onLogout={handleLogout}
      currentPage={currentPage}
      onPageChange={(page) => setCurrentPage(page as PageId)}
    >
      {renderPage()}
    </Layout>
  );
}

export default App;
